import { render, staticRenderFns } from "./GetCustomerDynamic.vue?vue&type=template&id=474ef444&scoped=true&"
import script from "./GetCustomerDynamic.vue?vue&type=script&lang=js&"
export * from "./GetCustomerDynamic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474ef444",
  null
  
)

export default component.exports